package screens.auth

import androidx.compose.runtime.*
import com.example.readingnotes.presentation.auth.AuthEvent
import com.example.readingnotes.presentation.auth.AuthViewModel
import com.example.readingnotes.resources.Strings
import org.jetbrains.compose.web.attributes.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import styles.AppStyleSheet

@Composable
fun AdminLoginScreen(
    onLoginSuccess: () -> Unit,
    onBackClick: () -> Unit,
    onRegisterClick: () -> Unit = {},
    onEmailLoginClick: () -> Unit = {},
    authViewModel: AuthViewModel,
) {
    val state by authViewModel.state.collectAsState()

    // Navigate to editor on successful login
    if (state.isLoggedIn) {
        LaunchedEffect(Unit) {
            onLoginSuccess()
        }
    }

    Div({ classes(AppStyleSheet.loginContainer) }) {
        // Back button
        Button({
            classes(AppStyleSheet.backButton)
            onClick { onBackClick() }
        }) { Text("← 戻る") }

        Div({ classes(AppStyleSheet.loginForm) }) {
            H2({ classes(AppStyleSheet.loginTitle) }) { Text(Strings.Auth.login) }

            // Username input field
            Div({ classes(AppStyleSheet.formGroup) }) {
                Label("admin-username-input") {
                    Text(Strings.Auth.username)
                }

                Input(type = InputType.Text) {
                    id("admin-username-input")
                    classes(AppStyleSheet.textInput)
                    value(state.usernameInput)
                    attr("autocomplete", "username")
                    attr("required", "true")
                    attr("aria-label", Strings.Auth.ariaUsername)
                    onInput { authViewModel.onEvent(AuthEvent.OnUsernameChanged(it.value)) }
                    if (state.isLoading) {
                        disabled()
                    }
                }
            }

            // Password input field
            Div({ classes(AppStyleSheet.formGroup) }) {
                Label("admin-password-input") {
                    Text(Strings.Auth.password)
                }

                Input(type = InputType.Password) {
                    id("admin-password-input")
                    classes(AppStyleSheet.textInput)
                    value(state.passwordInput)
                    attr("autocomplete", "current-password")
                    attr("required", "true")
                    attr("aria-label", Strings.Auth.ariaPassword)
                    onInput { authViewModel.onEvent(AuthEvent.OnPasswordChanged(it.value)) }
                    if (state.isLoading) {
                        disabled()
                    }
                }
            }

            // Error message display
            if (state.errorMessage != null) {
                Div({
                    classes(AppStyleSheet.formError)
                    attr("role", "alert")
                    attr("aria-live", "assertive")
                }) { Text(state.errorMessage!!) }
            }

            // Login button with loading state
            Div({ classes(AppStyleSheet.loginButtonGroup) }) {
                Button({
                    classes(AppStyleSheet.submitButton)
                    onClick {
                        authViewModel.onEvent(AuthEvent.OnLoginWithUsernameSubmit)
                    }
                    if (state.isLoading) {
                        disabled()
                    }
                }) {
                    Text(if (state.isLoading) Strings.Auth.loginLoading else Strings.Auth.loginButton)
                }
            }

            // Register link
            Div({ classes(AppStyleSheet.registerLink) }) {
                Text(Strings.Auth.noAccount)
                A(attrs = {
                    classes(AppStyleSheet.linkStyle)
                    onClick { onRegisterClick() }
                }) { Text(Strings.Auth.registerLink) }
                Br()
                Text(Strings.Auth.orText)
                A(attrs = {
                    classes(AppStyleSheet.linkStyle)
                    onClick { onEmailLoginClick() }
                }) { Text(Strings.Auth.emailLoginLink) }
            }
        }
    }
}
